<template>
  <div class="container-fluid">
    <div class="row mt-2">
      <div class="col-lg-12 bg-white border-radius-xl p-3">
        <div>
          <div class="text-center">
            <h4>Log Consulta de Afiliados</h4>
            <span class="text-center" style="font-weight: 400; font-size: small;">
              Ingresa los datos y realiza tu busqueda
            </span>
          </div>
          <hr class="horizontal dark" />
          <div class="row pl-2 pr-2">
            <div class="col-md-2">
              <label for="example-text-input" class="form-control-label">Desde</label>
              <datepicker
                v-model="fechaInicio"
                :="basicConfigDatePicker"
                :name="String(n)"
              ></datepicker>
            </div>
            <div class="col-md-2">
              <label class="form-control-label">Hasta</label>
              <datepicker
                v-model="fechaFin"
                :="basicConfigDatePicker"
                :name="String(n)"
              ></datepicker>
            </div>
            <div class="col-md-2">
              <label class="form-control-label">Documento de Identidad</label>
              <input type="text" class="form-control" v-model="documentoIdentidad">
            </div>
            <!-- <div class="col-md-2">
              <label class="form-control-label">ID Afiliado</label>
              <input type="text" class="form-control" v-model="idAfiliado">
            </div> -->
            <div class="col-md-2">
              <label for="example-text-input" class="form-control-label">Departamento</label>
              <vue-select
                :options="departmentosOpcions"
                label="text"
                v-model="departamento"
                :reduce="(option) => option.value"
              ></vue-select>
            </div>
            <div class="col-md-2">
              <label for="example-text-input" class="form-control-label">Programa</label>
              <input type="text" class="form-control" v-model="programa">
            </div>
            <div class="col-md-2">
              <button class="btn btn-addiuva-dark w-100" style="margin-top: 30px;"  @click="searchLog" title="Generar">
                <i class="fas fa-search pr-1"></i> Generar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ======================================= RESPONSE ======================================= -->
    <div class="row mt-2">
      <div class="col-lg-12 bg-white border-radius-xl p-3">
        <div class="row p-2">
          <Toast />
          <DataTable :value="afiliaciones" ref="dtAfiliaciones" stripedRows paginator :rows="10" :rowsPerPageOptions="[5, 10, 20, 50]" tableStyle="min-width: 50rem">
            <template #empty> <center class="text-gray">No hay afiliaciones que mostrar. </center></template>
            <Column field="id_log_consulta" header="Id Log" sortable></Column>
            <!-- <Column field="id_asegurado" header="Id Afiliado" sortable></Column> -->
            <Column field="documento_identidad" header="Doc. Identidad" sortable></Column>
            <Column field="sucursal" header="Sucursal" sortable></Column>
            <Column field="departamento" header="Departamento" sortable></Column>
            <Column field="fecha_consulta" header="Fecha Consulta" sortable></Column>
            <Column field="respuesta.status" header="Estado Respuesta" sortable></Column>
            <template #paginatorstart>
              <button class="btn btn-light" @click="exportCSV($event)" title="Exportar" v-if="afiliaciones.length>0">
                <i class="fas fa-download"></i> Exportar CSV
              </button>
            </template>
          </DataTable>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import VueSelect from "vue-select";
import Datepicker from 'vuejs3-datepicker';
import Toast from 'primevue/toast';
import axios from 'axios';
import authHeader from '../services/auth-header';
export default {
  name: "Reporte General",
  components: {
    VueSelect,
    DataTable,
    Column,
    Toast,
    Datepicker
  },
  data() {
    return {
      API_URL: process.env.VUE_APP_API_BASE_URL,
      basicConfigDatePicker: {
        "language": "es",
        "full-month-name":true,
        "monday-first": true,
        "iconWidth": "18",
        "iconHeight": "18",
        "use-utc": true,
      },
      fechaInicio: null,
      fechaFin:null,
      nombres: null,
      apellidos: null,
      numeroCertificado: null,
      documentoIdentidad: null,
      programa: null,
      estado: null,
      statusOptions: [
        {
          text: 'Vigente',
          value: 'VIGENTE'
        },
        {
          text: 'En Mora',
          value: 'MORA'
        },
        {
          text: 'Anulado',
          value: 'ANULADO'
        }
      ],
      formaPago: null,
      formasPagoOptions: [
        {
          text: 'Efectivo',
          value: 'Efectivo'
        },
        {
          text: 'Tarjeta de Crédito/Débito',
          value: 'Tarjeta de Crédito/Débito'
        }
      ],
      showProfileDropdown: false,
      afiliaciones: [],
      departamento: '',
      departmentosOptions: [
        {
          text: 'Todos',
          value: '',
        },
        {
          text: 'Beni',
          value: 'BO-B',
        },
        {
          text: 'Chochabamba',
          value: 'BO-C'
        },
        {
          text: 'Chuquisaca',
          value: 'BO-H'
        },
        {
          text: 'La Paz',
          value: 'BO-L'
        },
        {
          text: 'Pando',
          value: 'BO-N'
        },
        {
          text: 'Oruro',
          value: 'BO-O'
        },
        {
          text: 'Potosí',
          value: 'BO-P'
        },
        {
          text: 'Santa Cruz',
          value: 'BO-S'
        },
        {
          text: 'Tarija',
          value: 'BO-T'
        }
      ]
    };
  },
  methods: {
    searchLog() {
      this.afiliaciones = [];
      //let myArray = this.fechaInicio != null ? this.fechaInicio.toString().split("T") : [];
      //let fechaInicio = myArray[0] != '' ? myArray[0] : '';
      let payload = {
        "fecha_inicio": this.fechaInicio ? (this.changeIsoToDate(this.fechaInicio) ?? '') : '',
        "fecha_fin": this.fechaFin ? (this.changeIsoToDate(this.fechaFin) ?? '') : '',
        "documento_identidad" : this.documentoIdentidad ?? '',
        "id_afiliado" :  this.idAfiliado ?? '',
        "departamento" : this.departamento ?? '',
        "programa": this.programa ?? '',
      }
      // Send Data by Axios
      let url = this.API_URL + "/log_consulta_afiliados";
      axios({
        url: url,
        method: 'post',
        data: payload,
        headers: authHeader(),
      })
      .then(response => {
        if (response.data.status) {
            let data = response.data.data;
            let afiliaciones = [];
            data.forEach(a => {
              afiliaciones.push({
                id_log_consulta: a.id_log_consulta ?? '',
                id_asegurado: a.id_asegurado ?? '',
                documento_identidad: a.documento_identidad ?? '',
                sucursal: a.sucursal ?? '',
                departamento: a.departamento ?? '',
                respuesta: a.respuesta ?? '',
                fecha_consulta:  a.fecha_consulta ?? '',
                tarifa: a.tarifa ?? ''
              });
            });
            afiliaciones.forEach(afiliado => {
              afiliado.tarifa = (afiliado.tarifa != '') ? 'Bs. '+ afiliado.tarifa : '';
            });
            this.afiliaciones = afiliaciones;
        }
      })
      .catch(error => {
        console.log("Error: " + error);
      });
    },
    capitalize(str) {
      const str2 = str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
      return str2;
    },
    changeIsoToDate: function(isoDate) {
      let date = new Date(isoDate);
      let year = date.getFullYear();
      let month = date.getMonth()+1;
      let dt = date.getDate();
      if (dt < 10) {
        dt = '0' + dt;
      }
      if (month < 10) {
        month = '0' + month;
      }
      return year+'-' + month + '-'+dt;
    },
    validateRoute(){
      let menus = this.getProfileMe?.data.menu.filter( menu => {
        return (menu.path.toLowerCase().indexOf(this.$route.path.substring(1)) != -1);
      });
      if ( menus.length == 0 ) {
        this.$router.push({name: 'Home'});
      }
    },
    exportCSV() {
      this.$refs.dtAfiliaciones.exportCSV();
    }
  },
  watch: {
    getProfileMe(val) {
      if (val) {
        this.validateRoute();
      }
    }
  },
  computed: {
    getProfileMe() {
      return this.$store.getters["profile/me"];
    }
  },
  mounted() {
    // this.validateRoute();
  }
};
</script>
<style>
.p-splitbutton-defaultbutton{
  display: none !important;
}
.p-button-icon-only {
  border-radius: 50px !important;
}
</style>